// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__16Pyf","tagName":"styles_tagName__1DHnZ","crossIcon":"styles_crossIcon__UbvcG"};